import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import GlobalStyles from './styles/GlobalStyles';
import ScrollToTop from './components/ScrollToTop';
import CookieConsent from './components/CookieConsent';

// Páginas
import HomePage from './pages/HomePage';
import ServiciosPage from './pages/ServiciosPage';
import PreciosPage from './pages/PreciosPage';
import ProcesoPage from './pages/ProcesoPage';
import ContactoPage from './pages/ContactoPage';
import ReservaPage from './pages/ReservaPage';
import NotFoundPage from './pages/NotFoundPage';
import SobreNosotrosPage from './pages/SobreNosotrosPage';

// Páginas legales
import AvisoLegalPage from './pages/legal/AvisoLegalPage';
import PrivacidadPage from './pages/legal/PrivacidadPage';
import CookiesPage from './pages/legal/CookiesPage';

// Páginas de servicios específicos
import WebPymesPage from './pages/servicios/WebPymesPage';
import WebAutonomosPage from './pages/servicios/WebAutonomosPage';
import WebAbogadosPage from './pages/servicios/WebAbogadosPage';
import WebInmobiliariasPage from './pages/servicios/WebInmobiliariasPage';
import WebRestaurantesPage from './pages/servicios/WebRestaurantesPage';
import WebDentistasPage from './pages/servicios/WebDentistasPage';
import WebEmpresasPage from './pages/servicios/WebEmpresasPage';
import WebPsicologosPage from './pages/servicios/WebPsicologosPage';
import WebHotelesPage from './pages/servicios/WebHotelesPage';
import WebBodasPage from './pages/servicios/WebBodasPage';
import WebTerapeutasPage from './pages/servicios/WebTerapeutasPage';
import WebArquitectosPage from './pages/servicios/WebArquitectosPage';
import WebConstructorasPage from './pages/servicios/WebConstructorasPage';
import WebPeluqueriaPage from './pages/servicios/WebPeluqueriaPage';
import WebCafeteriaPage from './pages/servicios/WebCafeteriaPage';
import WebTallerPage from './pages/servicios/WebTallerPage';
import WebPintorPage from './pages/servicios/WebPintorPage';
import WebFarmaciaPage from './pages/servicios/WebFarmaciaPage';
import WebGestoriaPage from './pages/servicios/WebGestoriaPage';
import WebPizzeriaPage from './pages/servicios/WebPizzeriaPage';
import WebDiscotecaPage from './pages/servicios/WebDiscotecaPage';
import LandingPagesPage from './pages/servicios/LandingPagesPage';

// Páginas de demostración para las plantillas
import RestauranteDemoPage from './pages/plantillas/RestauranteDemoPage';
import DentistasDemoPage from './pages/plantillas/DentistasDemoPage';
import PeluqueriasDemoPage from './pages/plantillas/PeluqueriasDemoPage';
import TallerDemoPage from './pages/plantillas/TallerDemoPage';
import ArquitectosDemoPage from './pages/plantillas/ArquitectosDemoPage';
import ConstructoraDemoPage from './pages/plantillas/ConstructoraDemoPage';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <GlobalStyles />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/servicios" element={<ServiciosPage />} />
          <Route path="/precios" element={<PreciosPage />} />
          <Route path="/proceso" element={<ProcesoPage />} />
          <Route path="/sobre-nosotros" element={<SobreNosotrosPage />} />
          <Route path="/contacto" element={<ContactoPage />} />
          <Route path="/reserva" element={<ReservaPage />} />
          
          {/* Páginas servicios específicos */}
          <Route path="/servicios/diseno-web-pymes" element={<WebPymesPage />} />
          <Route path="/servicios/diseno-web-autonomos" element={<WebAutonomosPage />} />
          <Route path="/servicios/diseno-web-empresas" element={<WebEmpresasPage />} />
          <Route path="/servicios/diseno-web-abogados" element={<WebAbogadosPage />} />
          <Route path="/servicios/diseno-web-inmobiliarias" element={<WebInmobiliariasPage />} />
          <Route path="/servicios/diseno-web-restaurantes" element={<WebRestaurantesPage />} />
          <Route path="/servicios/diseno-web-dentistas" element={<WebDentistasPage />} />
          <Route path="/servicios/diseno-web-psicologos" element={<WebPsicologosPage />} />
          <Route path="/servicios/diseno-web-hoteles" element={<WebHotelesPage />} />
          <Route path="/servicios/diseno-web-bodas" element={<WebBodasPage />} />
          <Route path="/servicios/diseno-web-terapeutas" element={<WebTerapeutasPage />} />
          <Route path="/servicios/diseno-web-arquitectos" element={<WebArquitectosPage />} />
          <Route path="/servicios/diseno-web-constructoras" element={<WebConstructorasPage />} />
          <Route path="/servicios/diseno-web-peluqueria" element={<WebPeluqueriaPage />} />
          <Route path="/servicios/diseno-web-cafeteria" element={<WebCafeteriaPage />} />
          <Route path="/servicios/diseno-web-taller" element={<WebTallerPage />} />
          <Route path="/servicios/diseno-web-pintor" element={<WebPintorPage />} />
          <Route path="/servicios/diseno-web-farmacia" element={<WebFarmaciaPage />} />
          <Route path="/servicios/diseno-web-gestoria" element={<WebGestoriaPage />} />
          <Route path="/servicios/diseno-web-pizzeria" element={<WebPizzeriaPage />} />
          <Route path="/servicios/diseno-web-discoteca" element={<WebDiscotecaPage />} />
          <Route path="/servicios/landing-pages" element={<LandingPagesPage />} />
          
          {/* Páginas legales */}
          <Route path="/aviso-legal" element={<AvisoLegalPage />} />
          <Route path="/politica-privacidad" element={<PrivacidadPage />} />
          <Route path="/politica-cookies" element={<CookiesPage />} />

          {/* Rutas para demos de plantillas */}
          <Route path="/plantillas/restaurante" element={<RestauranteDemoPage />} />
          <Route path="/plantillas/dentista" element={<DentistasDemoPage />} />
          <Route path="/plantillas/peluqueria" element={<PeluqueriasDemoPage />} />
          <Route path="/plantillas/taller" element={<TallerDemoPage />} />
          <Route path="/plantillas/arquitectos" element={<ArquitectosDemoPage />} />
          <Route path="/plantillas/constructora" element={<ConstructoraDemoPage />} />
          
          {/* Ruta 404 */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <CookieConsent />
      </Router>
    </HelmetProvider>
  );
}

export default App;
